import { z } from 'zod';

export const all = async (params: object): Promise<DocumentType[]> => {
	let queryString = '';
	if (params) {
		const paramsAsString = JSON.stringify(params)
			.replace(/:/g, '=')
			.replace(/,/g, '&')
			.replace(/[{}"]/g, '');

		const searchParams = new URLSearchParams(paramsAsString);
		queryString = `?${searchParams.toString()}`;
	}

	const response = await fetch(`/DocumentType${queryString}`);

	return await response.json();
};

export const add = async (documentType: DocumentType): Promise<boolean> => {
	const res = await fetch(`/DocumentType`, {
		method: 'POST',
		body: JSON.stringify(documentType),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};

export const update = async (documentType: DocumentType): Promise<boolean> => {
	const res = await fetch(`/DocumentType`, {
		method: 'PATCH',
		body: JSON.stringify(documentType),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};

export const DocumentTypeSchema = z.object({
	id: z.number().nullable(),
	name: z.string().nonempty({ message: 'A document type name is required.' }),
	slug: z.string().nullable(),
	deletedOn: z.date().nullable(),
	documentClass: z.object({
		id: z.string().nonempty({ message: 'A document class id is required.' }),
		name: z.string().nonempty({ message: 'A document class name is required.' }),
	}),
});

export type DocumentType = z.infer<typeof DocumentTypeSchema>;
